import { getBaseUrl } from '../../maps/apiEnvironmentMap';
import { ExitValidation } from '../microservices';

const API_KEY = process.env.REACT_APP_API_KEY;
export class ExitValidationRequestPOST {
  readonly method: string = 'operation/exit/validation';
  public buildURL() {
    let baseURL = getBaseUrl('locker');
    return `${baseURL}/${this.method}`;
  }
  public generateContent(
    awbNumber: string,
    openCode?: string,
    qrCode?: string
  ) {
    const params: ExitValidationPayload = {};
    if (qrCode !== '') {
      params.qrCode = qrCode;
    } else {
      params.awbNumber = awbNumber;
      params.openCode = openCode;
    }
    return params;
  }
  public generateConfig(token: string) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'dhl-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    };
  }
}
type ExitValidationPayload = {
  awbNumber?: string;
  openCode?: string;
  qrCode?: string;
};
export type ExitValidationResponsePOST = {
  status: string;
  message: string;
  data: {
    message: string;
    errors: any;
    exitValidation: ExitValidation;
  };
};
